import React from 'react'

const Calculator = ({ className = '', style = {}, onClick }) => (
  <svg
    width='25'
    height='25'
    viewBox='0 0 25 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    style={{ cursor: 'pointer', ...style }}
    onClick={onClick}
  >
    <path
      d='M18.168 2.30078H6.16797C5.0634 2.30078 4.16797 3.19621 4.16797 4.30078V20.3008C4.16797 21.4054 5.0634 22.3008 6.16797 22.3008H18.168C19.2725 22.3008 20.168 21.4054 20.168 20.3008V4.30078C20.168 3.19621 19.2725 2.30078 18.168 2.30078Z'
      stroke='#9E9E9E'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.16797 6.30078H16.168'
      stroke='#9E9E9E'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.168 14.3008V18.3008'
      stroke='#9E9E9E'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.168 10.3008H16.178'
      stroke='#9E9E9E'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.168 10.3008H12.178'
      stroke='#9E9E9E'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.16797 10.3008H8.17797'
      stroke='#9E9E9E'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.168 14.3008H12.178'
      stroke='#9E9E9E'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.16797 14.3008H8.17797'
      stroke='#9E9E9E'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.168 18.3008H12.178'
      stroke='#9E9E9E'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.16797 18.3008H8.17797'
      stroke='#9E9E9E'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default Calculator
